<template>
  <div class="seasonality-picker">
    <div class="sp-label">Saisonnalité <span class="sp-hint">(impact environnemental)</span></div>
    <div class="sp-months">
      <button
        v-for="(month, idx) in MONTHS"
        :key="idx"
        type="button"
        class="sp-month-btn"
        :class="{ 'sp-month-btn--active': modelValue.includes(idx) }"
        @click="toggleMonth(idx)"
      >
        {{ month }}
      </button>
    </div>
    <div v-if="modelValue.length" class="sp-season-preview mb-2">
      Saison dominante : {{ seasonIcon }}
    </div>

    <div class="sp-label mt-3">Conservation</div>
    <div class="sp-frozen-row">
      <button
        type="button"
        class="sp-frozen-btn"
        :class="{ 'sp-frozen-btn--active': frozen }"
        @click="$emit('update:frozen', !frozen)"
        :title="frozen ? 'Surgelé (cliquer pour désactiver)' : 'Marquer comme surgelé'"
      >
        🧊 Surgelé
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] }, // indices de mois sélectionnés
  frozen: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'update:frozen']);

const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

// Hiver : déc(11), jan(0), fév(1), mar(2)
const WINTER = new Set([11, 0, 1, 2]);
// Été : juin(5), juil(6), août(7), sep(8)
const SUMMER = new Set([5, 6, 7, 8]);

const seasonIcon = computed(() => {
  if (!props.modelValue.length) return '';
  const hasWinter = props.modelValue.some(m => WINTER.has(m));
  const hasSummer = props.modelValue.some(m => SUMMER.has(m));
  if (hasWinter && hasSummer) return '❄️☀️';
  if (hasWinter) return '❄️';
  if (hasSummer) return '☀️';
  return '🌿'; // printemps ou automne uniquement
});

function toggleMonth(idx) {
  const current = [...props.modelValue];
  const pos = current.indexOf(idx);
  if (pos === -1) current.push(idx);
  else current.splice(pos, 1);
  emit('update:modelValue', current);
}
</script>

<style scoped>
.seasonality-picker {
  margin-top: 8px;
}
.sp-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(0,0,0,0.5);
  margin-bottom: 8px;
}
.sp-hint {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 11px;
  color: rgba(0,0,0,0.35);
}
.sp-months {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.sp-month-btn {
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1.5px solid rgba(0,0,0,0.15);
  background: transparent;
  color: rgba(0,0,0,0.55);
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1;
}
.sp-month-btn:hover {
  border-color: #7553FC;
  color: #7553FC;
}
.sp-month-btn--active {
  background: #7553FC;
  border-color: #7553FC;
  color: #fff;
  font-weight: 600;
}
.sp-frozen-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.sp-frozen-btn {
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1.5px solid rgba(0,0,0,0.15);
  background: transparent;
  color: rgba(0,0,0,0.55);
  cursor: pointer;
  transition: all 0.15s;
}
.sp-frozen-btn:hover {
  border-color: #4fc3f7;
  color: #0288d1;
}
.sp-frozen-btn--active {
  background: #e1f5fe;
  border-color: #4fc3f7;
  color: #0288d1;
  font-weight: 700;
}
.sp-season-preview {
  font-size: 13px;
  color: rgba(0,0,0,0.5);
}
</style>
